import React, { Fragment } from 'react'
import CanvasForFrames from './CanvasForFrames'
import CanvasForSets from './CanvasForSets'

const DesignedCanvas = () => (
  <Fragment>
    <CanvasForFrames />
    <CanvasForSets />
  </Fragment>
)

export default DesignedCanvas



// WEBPACK FOOTER //
// ./src/containers/DesignedCanvas/index.js